var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bd591d",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.696,
    height: 22,
    x: 7.652,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.696,
    height: 22,
    x: 7.652,
    rx: 2,
    transform: "rotate(90 11 11)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.70382cd4dac5392962dd016a30b82fe6.svg";
export { ForwardRef as ReactComponent };